import React from "react";

export const Advertisements = () => {
  return (
    <div className="container py-5">
      {/* --- SECCIÓN 1: INSTITUTO SAN PABLO --- */}
      <div id="itsp" className="mb-5 shadow-sm rounded-4 border overflow-hidden bg-white">
        <div className="bg-primary text-white p-4 text-center">
          <h2 className="fw-bold mb-2">Instituto Teológico San Pablo</h2>
          <p className="mb-0 opacity-90 mx-auto" style={{ maxWidth: '800px' }}>
            A TODOS LOS HERMANOS EN CRISTO QUE HAN SIDO LLAMADOS POR EL ESPÍRITU
            SANTO AL SANTO MINISTERIO PASTORAL.
          </p>
        </div>

        <div className="p-4">
          <div className="row g-4">
            {/* Perfil de Ingreso */}
            <div className="col-12 col-lg-6">
              <div className="h-100 p-3 bg-light rounded-3">
                <h4 className="text-primary mb-3 d-flex align-items-center">
                  <span className="badge bg-primary me-2">1</span> Perfil de Ingreso
                </h4>
                <ol className="text-secondary lh-lg">
                  <li>Tener la seguridad de su salvación</li>
                  <li>Ser bautizado en agua y con el Espíritu Santo</li>
                  <li>Ser mayor de edad (18 años cumplidos)</li>
                  <li>Miembro en plena comunión de la ICIAR y colaborador ministerial</li>
                  <li>Estudios concluidos (mínimo secundaria)</li>
                  <li>Testimonio impecable ante la iglesia y sociedad</li>
                  <li>Deseo de servir a Dios en el pastorado</li>
                  <li>Ser estudiante y/o trabajador con solvencia económica</li>
                  <li>Contar con permiso de padres (solteros) o apoyo de cónyuge (casados)</li>
                </ol>
              </div>
            </div>

            {/* Requisitos */}
            <div className="col-12 col-lg-6">
              <div className="h-100 p-3 bg-light rounded-3">
                <h4 className="text-primary mb-3 d-flex align-items-center">
                  <span className="badge bg-primary me-2">2</span> Requisitos de Inscripción
                </h4>
                <ul className="list-unstyled text-secondary lh-lg ps-2">
                  <li className="mb-2">✅ Aprobar materias del curso propedéutico</li>
                  <li className="mb-2">✅ Solicitar inscripción y cubrir cuota</li>
                  <li className="fw-bold text-dark mt-3 mb-2 border-bottom">Documentación (Original y Copia):</li>
                  <li className="ms-3">• Acta de nacimiento y matrimonio (si aplica)</li>
                  <li className="ms-3">• Cartas de trabajo, escuela y cónyuge</li>
                  <li className="ms-3">• Autorización del Pastor con visto bueno Presbiterial</li>
                  <li className="ms-3">• 8 fotografías tamaño infantil</li>
                  <li className="ms-3">• Constancia del máximo grado de estudios</li>
                  <li className="mt-3 text-dark fw-bold">💰 Pago de inscripción anual: $700.00 y mensualidad: $200.00</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* --- SECCIÓN 2: INSTITUTO DE FORMACIÓN MINISTERIAL --- */}
      <div id="ifm" className="shadow-sm rounded-4 border overflow-hidden bg-white">
        <div className="bg-dark text-white p-4 text-center">
          <h2 className="fw-bold mb-2 text-info">Instituto de Formación Ministerial</h2>
          <p className="mb-0 opacity-75">LLAMADOS POR EL ESPÍRITU SANTO A SERVIR AL SEÑOR</p>
        </div>

        <div className="bg-info bg-opacity-10 p-3 border-bottom text-center">
          <span className="fw-bold text-dark me-3">ESPECIALIDADES:</span>
          <div className="d-flex flex-wrap justify-content-center gap-2 mt-2">
            {['Ayuda Pastoral', 'Evangelista', 'Escuela Dominical', 'Administrador'].map((esp) => (
              <span key={esp} className="badge rounded-pill bg-info text-dark px-3 py-2 shadow-sm">{esp}</span>
            ))}
          </div>
        </div>

        <div className="p-4">
          <div className="row g-4 text-secondary">
            <div className="col-12 col-md-6">
              <h5 className="text-dark fw-bold">Perfil de Ingreso</h5>
              <hr className="text-info w-25 mt-1 mb-3" style={{height: '3px'}} />
              <small>
                Mismos requisitos de comunión, testimonio, mayoría de edad y respaldo familiar/pastoral mencionados en el instituto superior.
              </small>
            </div>
            <div className="col-12 col-md-6">
              <h5 className="text-dark fw-bold">Documentos a Llevar</h5>
              <hr className="text-info w-25 mt-1 mb-3" style={{height: '3px'}} />
              <ul className="list-unstyled small">
                <li>• Documentación personal básica (Actas, fotos)</li>
                <li>• Cartas de recomendación y autorización pastoral</li>
                <li className="fw-bold mt-2">💰 Pago de inscripción anual: $700.00 y mensualidad: $200.00</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};